// https://stackoverflow.com/questions/73969025/slots-not-working-in-my-vue-customelement-definecustomelement
// https://www.youtube.com/watch?v=SoPo7bnhbqA&ab_channel=ProgramWithErik

import { defineCustomElement } from "vue";
import { createPinia, setActivePinia } from "pinia";
import { VueQueryPlugin } from "@tanstack/vue-query";
import Widget from "@src/@widget/widget.ce.vue";

setActivePinia(createPinia());

const WidgetElement = defineCustomElement(Widget as any, {
  configureApp(app) {
    app.use(VueQueryPlugin);
  },
});

customElements.define("upm-widget", WidgetElement);

// Here we programmatically instantiate & append the UpmAlertsWrapperCE:

document.body.appendChild(
  new WidgetElement({
    as: "AlertsWrapper",
  })
);
